import './Button.scss';

export default function Button({children, type, className, ...props}) {
    return (
        <button 
            className={`btn ${className}`} 
            type={type} 
            {...props}
        >{children}</button>
    )
}